import CanteenReport from "./canteen.vue";
import RestaurantReport from "./restaurant.vue";
import PostReport from "./post.vue";

export default [
    {
        path: "/izvestaj",
        name: "izvestaj",
        displayName: "routes.izvestaj",
        icon: "mdi-file-chart",
        component: RestaurantReport,
        roles: ["admin", "restaurant", "report"],
    },
    {
        path: "/izvestaj-posta",
        name: "izvestaj-posta",
        displayName: "routes.izvestaj-posta",
        icon: "mdi-email",
        component: PostReport,
        roles: ["admin", "admin_post"],
    },
    {
        path: "/naplata/izvestaj-naplata",
        name: "izvestaj-naplata",
        displayName: "routes.izvestaj-naplata",
        icon: "mdi-file-document",
        component: CanteenReport,
        roles: ["admin", "restaurant", "report", "recipient"],
    },
];